/* eslint-disable react-hooks/exhaustive-deps */
import {
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Button,
  Rating,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useEffect } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import {
  CreateProvider,
  UpdateProvider,
} from "../../../core/redux/features/payment/paymentThunks";

import { useAppDispatch } from "../../../core/redux/hooks";
import {
  InvestingFormType,
  InvestingType,
} from "../../../core/types/payment.types";

interface InvestingFormProps extends Partial<InvestingType> {
  handleClose?: () => void;
}

const InvestingForm: React.FC<InvestingFormProps> = (props) => {
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    reset,
  } = useForm<InvestingFormType>({ mode: "all" });

  useEffect(() => {
    setValue("mobileApp", props?.mobileApp || undefined);
    setValue("trustPilotRating", props?.trustPilotRating || undefined);
    props?.availableCountriesUrl &&
      setValue("availableCountriesUrl", props?.availableCountriesUrl);
    setValue("bonus", props?.bonus || undefined);
    props?.assetTypes &&
      props?.assetTypes.length !== 0 &&
      setValue("assetTypes", props?.assetTypes);
    props?.minimumDeposit && setValue("minimumDeposit", props?.minimumDeposit);
    props?.fee && setValue("fee", props?.fee);
    setValue("bonusUrl", props?.bonusUrl || undefined);
    setValue("numberOfCountries", props?.numberOfCountries || undefined);
    props?.position && setValue("position", props?.position);
    setValue("websiteUrl", props?.websiteUrl || "");
    setValue("description", props?.description || "");
    setValue("logo", props?.logo || "");
    setValue("title", props?.title || "");
  }, [props]);

  const onSubmit: SubmitHandler<InvestingFormType> = (data) => {
    if (props.handleClose) {
      props.handleClose();
      dispatch(
        UpdateProvider({
          body: {
            ...data,
            position: data.position,
            numberOfCountries: Number(data.numberOfCountries),
          },
          id: String(props._id),
        })
      );
      // reset();
    } else {
      dispatch(
        CreateProvider({
          ...data,
          providerType: "investing",
          position: Number(data.position),
          minimumDeposit: parseInt(data.minimumDeposit.toString()),
          numberOfCountries: Number(data.numberOfCountries),
        })
      );
      // reset();
    }
  };

  return (
    <Stack
      width="100%"
      component="form"
      spacing={2}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Stack width="100%" spacing={2} direction="row">
        <TextField
          size="small"
          label={errors.title?.message ? errors.title?.message : "Title"}
          error={!!errors.title?.message}
          {...register("title", { required: "Title is reqired" })}
          fullWidth
        />
        <TextField
          size="small"
          label={
            errors.websiteUrl?.message
              ? errors.websiteUrl?.message
              : "Website Url"
          }
          error={!!errors.websiteUrl?.message}
          {...register("websiteUrl", { required: "Website Url is reqired" })}
          fullWidth
          type="url"
        />
      </Stack>

      <TextField
        size="small"
        label={errors.logo?.message ? errors.logo?.message : "Logo Url"}
        error={!!errors.logo?.message}
        {...register("logo", { required: "Logo Url is reqired" })}
        fullWidth
        type="url"
      />

      <Stack width="100%" spacing={2} direction="row" alignItems="center">
        <TextField
          size="small"
          label="TrustPilot Rating"
          {...register("trustPilotRating.rating")}
          fullWidth
        />
        <Controller
          name="trustPilotRating.rating"
          control={control}
          render={({ field }) => (
            <Rating
              {...field}
              defaultValue={props?.trustPilotRating?.rating || 0}
              precision={0.1}
              color="red"
              size="large"
              readOnly
            />
          )}
        />

        <TextField
          size="small"
          label="TrustPilot Rating Url"
          {...register("trustPilotRating.url")}
          fullWidth
          type="url"
        />
      </Stack>

      <Stack width="100%" spacing={2} direction="row">
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              {...register("mobileApp.exist")}
              defaultChecked={props?.mobileApp?.exist || false}
            />
          }
          label="Exist"
          labelPlacement="start"
        />
        <TextField
          size="small"
          label="GooglePlay URL"
          {...register("mobileApp.androidUrl")}
          type="url"
          fullWidth
        />
        <TextField
          size="small"
          label="AppStore URL"
          {...register("mobileApp.iosUrl")}
          type="url"
          fullWidth
        />
        <TextField
          size="small"
          label="AppGallery URL"
          {...register("mobileApp.huaWeiUrl")}
          type="url"
          fullWidth
        />
      </Stack>

      <Stack width="100%" spacing={2} direction="row">
        <TextField
          label="Available Countries Url"
          size="small"
          {...register("availableCountriesUrl")}
          fullWidth
          type="url"
        />
      </Stack>

      <Stack width="100%" spacing={2} direction="row">
        <TextField
          size="small"
          label="Position"
          {...register("position")}
          type="number"
          fullWidth
        />

        <TextField
          size="small"
          label="Number Of Countries"
          {...register("numberOfCountries")}
          type="number"
          fullWidth
        />
      </Stack>

      <Stack width="100%" spacing={2} direction="row">
        <TextField
          size="small"
          label="Bonus"
          {...register("bonus")}
          fullWidth
        />
        <TextField
          size="small"
          label="Bonus Url"
          {...register("bonusUrl")}
          fullWidth
          type="url"
        />
      </Stack>

      <Stack width="100%" spacing={2} direction="row">
        <FormControl size="small" fullWidth>
          <InputLabel>Available Assets</InputLabel>
          <Controller
            name="assetTypes"
            control={control}
            defaultValue={[]}
            render={({ field }) => (
              <Select size="small" label="Available Assets" multiple {...field}>
                {availableAssets.map((item, idx) => (
                  <MenuItem key={idx} value={item.value}>
                    {item.title}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </FormControl>

        <TextField
          size="small"
          label="Minimum Deposit"
          type="number"
          {...register("minimumDeposit")}
          fullWidth
        />
      </Stack>
      <Stack width="100%" spacing={2} direction="row">
        <TextField
          label={errors.fee?.message ? errors.fee?.message : "Fee"}
          error={!!errors.fee?.message}
          size="small"
          fullWidth
          {...register("fee", { required: "Fee is reqired" })}
        />
        <TextField
          size="small"
          label="Fee Url"
          {...register("feeUrl")}
          fullWidth
          type="url"
        />
      </Stack>

      <TextField
        label={
          errors.description?.message
            ? errors.description?.message
            : "Description"
        }
        error={!!errors.description?.message}
        {...register("description", { required: "Description is reqired" })}
        fullWidth
        multiline
        rows={6}
      />
      <Button variant="contained" sx={{ bgcolor: "#239f5e" }} type="submit">
        {props._id ? "Save" : "Create"}
      </Button>
    </Stack>
  );
};

export default InvestingForm;

const availableAssets = [
  { title: "Stocks", value: "stocks" },
  { title: "Options", value: "options" },
  { title: "Futures", value: "futures" },
  { title: "Crypto", value: "crypto" },
];
